// import { CheckCheck, Columns3Icon, Users } from "lucide-react";
import { BarCode02Icon } from "hugeicons-react";
import { Box, FileX2, Headset, Package, SquareUser } from "lucide-react";
import { Agent } from "../components/Icons/Agent";
import { Calendar } from "../components/Icons/Calendar";
import { ConnectIcon } from "../components/Icons/Connect";
import { Connecting } from "../components/Icons/Connecting";
import { Deli } from "../components/Icons/Deli";
import { Earth } from "../components/Icons/Earth";
import { Home } from "../components/Icons/Home";
import { List } from "../components/Icons/List";
import { Network } from "../components/Icons/Network";
import { Pay } from "../components/Icons/Pay";
import { PinLocation } from "../components/Icons/PinLocation";
import { Power } from "../components/Icons/Power";
import { Setting } from "../components/Icons/Setting";
import { Square } from "../components/Icons/Square";
import { TaskDaily } from "../components/Icons/TaskDaily";
import { User } from "../components/Icons/User";
import { UserList } from "../components/Icons/UserList";

export const menuAdmin = [
  {
    name: "Tableau de bord",
    link: "/dashboard",
    icon: <Home />,
  },
  {
    name: "Eligibilités",
    link: "/liste-eligibilite",
    icon: <PinLocation />,
  },
  {
    name: "Abonnement",
    link: "/abonnements",
    icon: <TaskDaily />,
  },
  {
    name: "Paiements",
    link: "/paiements",
    icon: <Pay />,
  },
  {
    name: "Livraison",
    link: "/livraisons",
    icon: <Deli />,
  },
  {
    name: "Identification",
    link: "/identification",
    icon: <UserList />,
  },
  {
    name: "Rendez-vous",
    link: "/intention-rdv",
    icon: <TaskDaily />,
  },
  {
    name: "Survey",
    link: "/servey",
    icon: <Calendar />,
  },
  {
    name: "Logs",
    link: "/logs",
    icon: <Calendar />,
  },
  {
    name: "Activation",
    link: "/installation",
    icon: <Power />,
  },
  {
    name: "Raccordement",
    link: "/Raccordement",
    icon: <ConnectIcon />,
  },
  {
    name: "Souscription",
    link: "/souscription",
    icon: <Square />,
  },
  {
    name: "Test de connectivité",
    link: "/test",
    icon: <Network />,
  },
  {
    name: "Provisioning",
    link: "/provisioning",
    icon: <List />,
  },
  {
    name: "Agents",
    link: "/agents",
    icon: <Agent />,
  },
  {
    name: "Planing",
    link: "/planing",
    icon: <TaskDaily />,
  },
  {
    name: "Utilisateurs",
    link: "/utilisateurs",
    icon: <User />,
  },
  {
    name: "Parametres",
    link: "/parametres",
    icon: <Setting />,
  },
  {
    name: "Zone couverture",
    link: "/zone-couverture",
    icon: <Earth />,
  },
  {
    name: "Point de branchement optique",
    link: "/pbo",
    icon: <Connecting />,
  },
  {
    name: "Numeros FTTH",
    link: "/numeroFtth",
    icon: <BarCode02Icon />,
  },
  {
    name: "",
    link: "/corbeille-rdv",
    icon: <Box />,
  },
  {
    name: "",
    link: "/corbeille-rdv-prestataire",
    icon: <Package />,
  },
  {
    name: "",
    link: "/ventes-supprimees",
    icon: <FileX2 size={20} />,
  },
  {
    name: "",
    link: "/corbeille-maintenance",
    icon: <Headset size={20} />,
  },
  {
    name: "",
    link: "/prestataire",
    icon: <SquareUser size={20} />,
  },
  {
    name: "",
    link: "/equipes",
    icon: <User size={20} />,
  },
];

export const menuComm = [
  {
    name: "Tableau de bord",
    link: "/dashboard",
    icon: <Home />,
  },
  {
    name: "Eligibilités",
    link: "/liste-eligibilité",
    icon: <PinLocation />,
  },
  {
    name: "Abonnement",
    link: "/abonnements",
    icon: <TaskDaily />,
  },
  {
    name: "Paiements",
    link: "/paiements",
    icon: <Pay />,
  },
  {
    name: "Livraison",
    link: "/livraisons",
    icon: <Deli />,
  },
  {
    name: "Identification",
    link: "/identification",
    icon: <UserList />,
  },
  {
    name: "Rendez-vous",
    link: "/intention-rdv",
    icon: <TaskDaily />,
  },
];

export const menuRdv = [
  {
    name: "Prise de rendez-vous",
    link: "/intention-rdv",
    icon: <TaskDaily />,
  },
  // {
  //   name: "Rendez-vous",
  //   link: "/rdv",
  //   icon: <Calendar />,
  // }
];

export const menuTech = [
  {
    name: "Tableau de bord",
    link: "/dashboard",
    icon: <Home />,
  },
  {
    name: "Prise de rendez-vous",
    link: "/intention-rdv",
    icon: <TaskDaily />,
  },
  {
    name: "Servey",
    link: "/servey",
    icon: <Calendar />,
  },
  {
    name: "Activation en ligne",
    link: "/activation",
    icon: <Power />,
  },
  {
    name: "Raccordement",
    link: "/Raccordement",
    icon: <ConnectIcon />,
  },
  {
    name: "Souscription",
    link: "/souscription",
    icon: <Square />,
  },
  {
    name: "Test de connectivité",
    link: "/test",
    icon: <Network />,
  },
];
